import { resource, RequestConfig } from '../helper/resource';

/**
 * [Auth]买卖点
 */
export function queryBuyAndSellPointUsingPOST_1(
  req: InfoCodeClientDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcBuySellPoint> {
  return resource.post('/MMFund/queryBuyAndSellPoint', req, config);
}

/**
 * [No Auth]各种基金基本信息
 */
export function queryFundBaseInfoUsingPOST_1(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundInfoDto> {
  return resource.postNoAuth('/MMFund/queryFundBaseInfo', req, config);
}

/**
 * [No Auth]基金档案外部
 */
export function queryFundInfoUsingPOST_1(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundInfoDto> {
  return resource.postNoAuth('/MMFund/queryFundInfo', req, config);
}

/**
 * [No Auth]基金经理
 */
export function queryFundManagerInfoUsingPOST_1(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListFundManagerInfoDto> {
  return resource.postNoAuth('/MMFund/queryFundManagerInfo', req, config);
}

/**
 * [No Auth]基金页面类型
 */
export function queryFundPageTypeUsingPOST_2(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundPageTypeDto> {
  return resource.postNoAuth('/MMFund/queryFundPageType', req, config);
}

/**
 * [No Auth]产品概要
 */
export function queryFundProfileUsingPOST_2(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultLcAnnouncement> {
  return resource.postNoAuth('/MMFund/queryFundProfile', req, config);
}

/**
 * [No Auth]阶段涨幅
 */
export function queryFundReturnPerformUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcFundReturnRank> {
  return resource.postNoAuth('/MMFund/queryFundReturnPerform', req, config);
}

/**
 * [No Auth]产品宣传图链接
 */
export function queryPublicityPictureUrlUsingPOST_1(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultstring> {
  return resource.postNoAuth('/MMFund/queryPublicityPictureUrl', req, config);
}

/**
 * [No Auth]七日年化
 */
export function queryWeeklyYieldUsingPOST(
  req: InfoPeriodDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcMmfYieldPerformance> {
  return resource.postNoAuth('/MMFund/queryWeeklyYield', req, config);
}

/**
 * [No Auth]历史七日年化
 */
export function queryWeeklyYieldHistUsingPOST(
  req: InfoPageDto | void,
  config?: RequestConfig
): Promise<ApiResultPageLcMmfYieldPerformance> {
  return resource.postNoAuth('/MMFund/queryWeeklyYieldHist', req, config);
}

/**
 * [No Auth]阅读文件留痕
 */
export function addFundLeaveMarksUsingPOST_1(req: LcFundLeaveMarks | void, config?: RequestConfig): Promise<void> {
  return resource.postNoAuth('/MMFund/saveFundLeaveMarks', req, config);
}

/**
 * [No Auth]根据产品代码查询产品文件路径
 */
export function searchFindFileUsingPOST_1(
  req: SearchFindFileParam | void,
  config?: RequestConfig
): Promise<ApiResultListLcFundFilePathVo> {
  return resource.postNoAuth('/MMFund/searchFindFile', req, config);
}
